var Events = {
    events: [],
    attach: function(name, callback) {
        if (typeof this.events[name] == "undefined") {
            this.events[name] = [];
        }

        this.events[name].push(callback);

    },

    notify: function(name) {
        if (typeof this.events[name] != "undefined") {
            for(var callback of this.events[name]) {
                callback.call();
            }
        }
    }
}